import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";

import {
  createAuthUserWithEmailAndPassword,
  createUserDocument,
  updateUserProfileWithDisplayName,
} from "../../utils/firebase-utils";
import Button from "../form-components/button";
import FormInput from "../form-components/form-input";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";

import { UserContext } from "../../contexts/user-context";
import { GuestSignUpModalContext } from "../../contexts/guest-signup-modal-context";
import { SaveGuestDetailsContext } from "../../contexts/save-guest-details-context";

import "../form-components/button.styles.css";
import "./sign-in-form.styles.css";

const GuestSignUpForm = () => {
  const { guestDetails } = useContext(SaveGuestDetailsContext);

  const defaultFormFields = {
    displayName: guestDetails.displayName,
    email: guestDetails.email,
    password: "",
  };

  const [formFields, setFormFields] = useState(defaultFormFields);
  const { displayName, email, password } = formFields;

  const navigate = useNavigate();

  const { setCurrentUser } = useContext(UserContext);
  const { setOpenGuestSignUpModal } = useContext(GuestSignUpModalContext);

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const handleModelClose = () => {
    setOpenGuestSignUpModal(false);
  };

  const setUser = (data) => {
    localStorage.setItem("user", JSON.stringify(data));
    setCurrentUser(data);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    ReactGA.event({
      category: "form-actions",
      action: "sign-up-guest",
    });

    try {
      await createAuthUserWithEmailAndPassword(email, password);
      const user = await updateUserProfileWithDisplayName(displayName);

      await createUserDocument(user);
      await setUser({ ...user, role: "user" });

      setOpenGuestSignUpModal(false);
      resetFormFields();
      navigate("/");
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        alert("Cannot create user: email already in use");
      } else if (error.code === "auth/weak-password") {
        alert("Password should be at least 6 characters");
      } else {
        console.log("user creation encountered an error", error);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <div className="signin-modal">
      <div className="signin-modal-content">
        <div className="signin-modal-header">
          <Button
            className="signin-modal-close-button"
            onClick={handleModelClose}
          >
            <FontAwesomeIcon
              icon={faRectangleXmark}
              style={{ color: "#363832" }}
              size="2xl"
            />
          </Button>
        </div>

        <h1 className="signin-modal-heading-guest">Create an account</h1>

        <p className="signin-modal-text">
          Enter a password and sign up to save your details for future
        </p>

        <form onSubmit={handleSubmit}>
          <FormInput
            label="Display Name"
            inputType="signIn"
            type="text"
            required
            onChange={handleChange}
            name="displayName"
            value={displayName}
          />

          <FormInput
            label="Email"
            inputType="signIn"
            type="email"
            required
            onChange={handleChange}
            name="email"
            value={email}
          />

          <FormInput
            label="Password"
            inputType="signIn"
            type="password"
            required
            onChange={handleChange}
            name="password"
            value={password}
          />

          <div className="signin-button-container">
            <Button type="submit" buttonType="lowlandsGreen">
              Sign Up
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GuestSignUpForm;
